import {
  OLD_PASSWORD_PROPERTY,
  NEW_PASSWORD_PROPERTY,
  NEW_PASSWORD_CONFIRMATION_PROPERTY
} from './constants'
import { constants } from 'services/validator'

export default {
  oldPassword: {
    name: OLD_PASSWORD_PROPERTY,
    label: 'Current Password',
    type: 'password',
    maxLength: constants.PASSWORD_MAX_LENGTH,
    required: true,
    'data-at-accountdetails-currentpassword': true
  },
  password: {
    name: NEW_PASSWORD_PROPERTY,
    label: 'New Password',
    type: 'password',
    maxLength: constants.PASSWORD_MAX_LENGTH,
    required: true,
    'data-at-accountdetails-newpassword': true
  },
  confirmPassword: {
    name: NEW_PASSWORD_CONFIRMATION_PROPERTY,
    label: 'Confirm Password',
    type: 'password',
    maxLength: constants.PASSWORD_MAX_LENGTH,
    required: true,
    'data-at-accountdetails-confirmpassword': true
  }
}
